const GET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID = 'GET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID';
const SET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID = 'SET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID';

const GET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID = 'GET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID';
const SET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID = 'SET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID';

const GET_SAVE_APPROVAL_HIERARCHY = 'GET_SAVE_APPROVAL_HIERARCHY';
const SET_SAVE_APPROVAL_HIERARCHY = 'SET_SAVE_APPROVAL_HIERARCHY';

const GET_VALIDATE_TITLE = 'GET_VALIDATE_TITLE';
const SET_VALIDATE_TITLE = 'SET_VALIDATE_TITLE';

const GET_SAVE_TITLE = 'GET_SAVE_TITLE';
const SET_SAVE_TITLE = 'SET_SAVE_TITLE';

const GET_APPROVAL_HIERARCHY_TABLE_EXCEL = 'GET_APPROVAL_HIERARCHY_TABLE_EXCEL';
const SET_APPROVAL_HIERARCHY_TABLE_EXCEL = 'SET_APPROVAL_HIERARCHY_TABLE_EXCEL';

const GET_IS_VALID_SKIP_APPROVAL = 'GET_IS_VALID_SKIP_APPROVAL';
const SET_IS_VALID_SKIP_APPROVAL = 'SET_IS_VALID_SKIP_APPROVAL';

export{
    GET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID,
    SET_APPROVAL_HIERARCHY_BY_SUPER_REGION_ID,
    GET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID,
    SET_ADDITIONAL_APPROVAL_BY_SUPER_REGION_ID,
    GET_SAVE_APPROVAL_HIERARCHY,
    SET_SAVE_APPROVAL_HIERARCHY,
    GET_VALIDATE_TITLE,
    SET_VALIDATE_TITLE,
    GET_SAVE_TITLE,
    SET_SAVE_TITLE,
    GET_APPROVAL_HIERARCHY_TABLE_EXCEL,
    SET_APPROVAL_HIERARCHY_TABLE_EXCEL,
    GET_IS_VALID_SKIP_APPROVAL,
    SET_IS_VALID_SKIP_APPROVAL
}